import { Component, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { AppState, selectUserTheme } from '@app/core/ngrx';

/**
 * AlertDialogComponent
 */
@Component({
  selector: 'ecp-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false,
})
export class AlertDialogComponent {
  // @select(['user', 'profile', 'theme'])
  public theme$: Observable<string>;
  /**
   * constructor
   * @param {MatDialogRef<AlertDialogComponent>} dialogRef
   * @param data
   */
  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.theme$ = this.store.pipe(select(selectUserTheme));
  }

  /**
   * closeDialog
   */
  @HostListener('document:keydown.escape')
  closeDialog() {
    this.dialogRef.close();
  }
}
